export const CREATE_ARTIST_URL = '/artists';
export const GET_ARTISTS_URL = '/artists';
export const GET_ARTIST_SONGS_URL = (id) => `/artists/${id}/songs`;
export const GET_ARTIST_ALBUMS_URL = (id) => `/artists/${id}/albums`;
export const CHECK_ARTIST_NAME_URL = '/artists/check-name';
export const DELETE_ARTIST_URL = (id) => `/artists/${id}`;
